export const elapsedTime = (utcTimestamp: number, newerUtcTimestamp?: number) => {
    const start = new Date(utcTimestamp).getTime(); // UTC timestamp in ms
    const now = newerUtcTimestamp ? new Date(newerUtcTimestamp).getTime() : Date.now();
    const diffMs = now - start;

    return formatTime(diffMs);
};

export const formatTime = (timeMs: number) => {
    const hours = Math.floor(timeMs / (1000 * 60 * 60));
    const minutes = Math.floor((timeMs % (1000 * 60 * 60)) / (1000 * 60));

    // pad to 2 digits
    const hh = String(hours).padStart(2, '0');
    const mm = String(minutes).padStart(2, '0');

    return `${hh}h:${mm}m`;
};
